const CLOUDFRONT_URL = process.env.REACT_APP_AWS_CLOUDFRONT_URL;

const getGameIcon = (name: string) => encodeURI(`${CLOUDFRONT_URL}games/v2/${name}.png`);

const getWeaponIcon = (weapon: string) => encodeURI(`${CLOUDFRONT_URL}weapons/v2/${weapon}.webp`);

// Same values as the app, tuned in the design in px of a 22px high card: the long weapons are
// tilted so their tip points to the top right corner; the card leaves ~9px on each side of the icon.
interface WeaponFit {
  rotate: number;
  scale: number;
  card: number;
  // Recenters the icon once tilted.
  dx: number;
  dy: number;
}

const WEAPON_CARD_DESIGN_HEIGHT = 22;

const fit = (rotate: number, scale: number, card: number, dx: number, dy: number): WeaponFit => ({
  rotate,
  scale,
  card,
  dx,
  dy,
});

const WEAPON_FITS: { [weapon: string]: WeaponFit } = {
  Assault: fit(12, 0.855, 35, -0.2, -0.2),
  Sniper: fit(12.5, 0.81, 34, -0.2, -0.2),
  'Shot Gun': fit(16.5, 0.855, 33.5, -0.1, -0.3),
  Support: fit(15.5, 0.81, 35, 0.4, -0.1),
  Launcher: fit(12.5, 0.81, 34.5, -0.2, -0.2),
  Bomb: fit(11.5, 0.81, 33.5, -0.2, 0.1),
  Knife: fit(13.5, 0.81, 31, 0.1, 0),
  Gun: fit(28, 0.855, 29.5, -0.9, -1),
  'Machine Gun': fit(16, 0.855, 33.5, 0.7, 0.3),
  Grenade: fit(0, 0.73, 29.5, -0.4, 0),
  C4: fit(0, 0.81, 30.5, 0, 0),
  Hand: fit(0, 0.77, 29, 0.1, 0),
  Shield: fit(0, 0.73, 30.5, 0, 0),
  Tank: fit(10, 0.81, 31, 0.2, -0.1),
  Plane: fit(6, 0.81, 34.5, -0.1, -1),
  Helicopter: fit(0, 0.81, 33, 0, 0.3),
};

// A weapon added later keeps the previous look until it is tuned.
const DEFAULT_FIT: WeaponFit = fit(0, 1, 29.8, 0, 0);

const getWeaponFit = (weapon: string) => WEAPON_FITS[weapon] || DEFAULT_FIT;

// "Call of Duty Warzone" is shown "Warzone": the chips stay short.
const getGameShortName = (name: string) => {
  const prefix = 'Call of Duty ';
  if (name.startsWith(prefix)) {
    return name.slice(prefix.length);
  }
  return name;
};

export {
  getGameIcon,
  getGameShortName,
  getWeaponFit,
  getWeaponIcon,
  WEAPON_CARD_DESIGN_HEIGHT,
};
